import React, { Component } from 'react';
import Notificacao from '../../../components/Notificacao';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';
import PreLoaderWidget from '../../../components/Loader';
import { Editor } from "@tinymce/tinymce-react";
import HeaderModal from "../../../gb-components/HeaderModal";
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
} from '../../../helpers/firebase-config';
import { setReceituario } from '../../../Libs/paciente';
import moment from 'moment';

import {
  //sendEmailReceituario,
  openReceituario,
  // sendEmailWhats
} from '../../../Libs/Docs.js';

import ModalEnvio from "../../../gb-components/ModalEnvio";

export default class CadastrarReceituario extends Component {
  state = {
    loading: false,
    id: '',
    prescricao: '',
    sending: false,
    isVisibleSend: false,
    emailSend: '',
    telefonesSend: '',
    dcc: null
  };

  componentDidMount = () => {
    const id = this.props.id ? this.props.id : this.props.match.params.id;
    let refPaciente = Libfirebase.collection("paciente").doc(id);

    refPaciente.get().then(pac => {
      let telefones = pac.data().telefones;

      // SE TIVER WHATSAPP ELE VAI SER PRIORIDADE
      if (pac.data().whatsapp) {
        telefones = pac.data().whatsapp
      }

      try {
        if (telefones && typeof (telefones) == 'string' && telefones != '') {
          telefones = telefones.replaceAll('-', '').replaceAll(' ', '').replacell('(', '').replaceAll(')', '');
        } else {
          telefones = "";
        }
      } catch (e) {

      }

      this.setState({ emailSend: pac.data().email, telefonesSend: telefones });
    });
    this.setState({ id });
  };

  _setCadastro = async () => {
    this.setState({ loading: true });
    const {
      prescricao,
      id
    } = this.state;

    const user = firebaseAuth.currentUser;

    //valida os campos
    if (
      (prescricao !== '')
    ) {
      let idProfissional = 0;

      await Libfirebase
        .collection('usuario')
        .where('email', '==', user.email)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            if (doc.exists) {
              idProfissional = doc.id;
            } else {
            }
          });
        })
        .catch(erro => console.log(erro));


      const refProfissional = await Libfirebase
        .collection('usuario')
        .doc(idProfissional);

      const data = {
        prescricao,
        DataCriacao: moment().format('DD-MM-YYYY'),

        Hora: moment().format('HH:mm:ss'),
        Date: new Date(),
        refProfissional
      };

      setReceituario(data, id)
        .then(dcc => {

          this.setState({ dcc, isVisibleSend: true, loading: false });
          // this.setState({ isVisibleSend: true });
          // confirmAlert({
          //   title: 'Receituario cadastrado com sucesso',
          //   message: 'O que deseja fazer?',
          //   buttons: [
          //     {
          //       label: 'Visualizar',
          //       onClick: () => {
          //         openReceituario(this.state.id, dcc.id);
          //         this.props.history.push('/paciente/historico/' + this.state.id);
          //       }
          //     },
          //     {
          //       label: 'Enviar Paciente (e-mail)',
          //       onClick: async () => {
          //         this.setState({ loading: true });

          //         await sendEmailReceituario(this.state.id, dcc.id).then((res) => {
          //           alert(res);
          //         }).catch((err) => {
          //           alert(err);
          //         });
          //         this.setState({ loading: false });
          //         this.props.history.push('/paciente/historico/' + this.state.id);
          //       }
          //     },
          //     {
          //       label: 'Voltar Histórico',
          //       onClick: () => {
          //         this.props.history.push('/paciente/historico/' + this.state.id);

          //       }
          //     }
          //   ]
          // });
        })
        .catch(erro => {
          this.setState({
            loading: false,
            notifition: true,
            msg: erro.code,
            nameclass: 'alert-danger'
          });

        });
    } else {
      this.setState({
        loading: false,
        notifition: true,
        msg: 'Favor entrar com pelo menos um receituario.',
        nameclass: 'alert-danger'
      });
    }
  };

  handleEditorChange = (content, editor) => {
    this.setState({ prescricao: content })
  }

  render() {
    return (
      <div style={{ marginTop: '20px' }}>
        <Loading loading={this.state.loading} />

        {(this.state.dcc) ? <ModalEnvio visible={this.state.isVisibleSend}
          close={() => { this.setState({ isVisibleSend: false }); this.props.onClose() }}
          pacienteId={this.state.id}
          card={'receituario'}
          docId={this.state.dcc.id}
          email={this.state.emailSend}
          telefone={this.state.telefonesSend}
          visualizar={() => { openReceituario(this.state.id, this.state.dcc.id); }} /> : null}

        {/* 
            <Link
              to={this.props.onClose ? '#' : '/paciente/historico/' + this.state.id}
              className="btn btn-outline-info btn-rounded"
              onClick={() => { if (this.props.onClose) this.props.onClose() }}
            >
              <i className="fa fa-angle-left" /> Voltar
            </Link>
            <br />
            <br /> */}
        {this.state.notifition ? (
          <Notificacao
            msg={this.state.msg}
            nameclass={this.state.nameclass}
          />
        ) : null}
        <HeaderModal
          title="Nova Prescrição"
        />

        <form className="form-horizontal pt-2">
          {/*  <Input
            placeholder="Cadastre um novo receituário"
            type="textarea"
            id="prescricao"
            rows="15"
            value={this.state.prescricao}
            onChange={text => { this.setState({ prescricao: text }) }}
            noForm
          /> */}
          <Editor
            id="prescricao"
            onEditorChange={text => { this.setState({ prescricao: text }) }}
            value={this.state.prescricao}
            apiKey="jl2uw5yob5e4avhldqg1sm0npw0zkdayoz2xj4wwgr2lj1ei"
            init={{
              language: 'pt_BR',
              plugins: "",
              placeholder: "Cadastre um novo receituário",
              height: 350,
              browser_spellcheck: true,
              toolbar: "undo redo spellcheckdialog  | fontselect fontsizeselect | bold italic underline forecolor backcolor | align lineheight checklist bullist numlist | indent outdent | removeformat typography",
            }}
          ></Editor>
          <div className="col-sm-12">
            {(this.state.loading ? (
              <center><PreLoaderWidget></PreLoaderWidget></center>
            ) : (
              <button
                type="button"
                onClick={() => this._setCadastro()}
                className="btn gb-button right mt-3"
              >
                Salvar
              </button>
            ))}
          </div>
        </form>
      </div>
    );
  }
}
